const buttonLoadingState = new WeakMap();
const loadingRequests = new Map();

let lastActionButton = null;
let lastActionTime = 0;
let listenersInitialized = false;

const getActionButton = (target) => {
  if (!(target instanceof Element)) {
    return null;
  }

  const button = target.closest("button, input[type='submit']");

  if (!button || button.disabled) {
    return null;
  }

  return button;
};

const rememberActionButton = (button) => {
  if (!button) {
    return;
  }

  lastActionButton = button;
  lastActionTime = Date.now();
};

export const initializeButtonLoading = () => {
  if (listenersInitialized || typeof document === "undefined") {
    return;
  }

  document.addEventListener(
    "click",
    (event) => rememberActionButton(getActionButton(event.target)),
    true
  );

  document.addEventListener(
    "submit",
    (event) => {
      const submitter = event.submitter || document.activeElement;
      rememberActionButton(getActionButton(submitter));
    },
    true
  );

  listenersInitialized = true;
};

const startButtonLoading = (button, requestId) => {
  if (!button || !button.isConnected || loadingRequests.has(requestId)) {
    return false;
  }

  const state = buttonLoadingState.get(button) || {
    requestCount: 0,
    wasDisabled: button.disabled,
    previousAriaBusy: button.getAttribute("aria-busy"),
  };

  state.requestCount += 1;
  buttonLoadingState.set(button, state);
  loadingRequests.set(requestId, button);

  button.classList.add("button-loading");
  button.disabled = true;
  button.setAttribute("aria-busy", "true");

  return true;
};

export const startLastButtonLoading = (requestId) => {
  const buttonIsRecent = Date.now() - lastActionTime < 5000;

  if (!buttonIsRecent) {
    return false;
  }

  return startButtonLoading(lastActionButton, requestId);
};

export const stopButtonLoading = (requestId) => {
  const button = loadingRequests.get(requestId);

  if (!button) {
    return;
  }

  loadingRequests.delete(requestId);

  const state = buttonLoadingState.get(button);

  if (!state) {
    return;
  }

  state.requestCount = Math.max(0, state.requestCount - 1);

  if (state.requestCount > 0) {
    buttonLoadingState.set(button, state);
    return;
  }

  button.classList.remove("button-loading");
  button.disabled = state.wasDisabled;

  if (state.previousAriaBusy === null) {
    button.removeAttribute("aria-busy");
  } else {
    button.setAttribute("aria-busy", state.previousAriaBusy);
  }

  buttonLoadingState.delete(button);
};

export const createLoadingToken = () =>
  `component-loading-${Date.now()}-${Math.random().toString(36).slice(2)}`;
